import { useEffect } from "react";
import { Link } from "react-router-dom";
import classes from "./SubscribeSuccess.module.css";

const SubscribeSuccess = ({ isAuth }) => {
  //Why the fuck can't I use scroolTo??????????????????
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  // if (!isAuth) {
  //   return <Navigate to="/" replace />;
  // }
  return (
    <div className={classes.successContainer}>
      <p className={classes.successMessage}>謝謝你的訂閱🥰</p>
      <Link to="/" className={classes.redirect}>
        返回首頁
      </Link>
    </div>
  );
};

export default SubscribeSuccess;
